import React, { useState } from "react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";

const revenueRanges = [
  "Less than $100,000",
  "$100,000 - $250,000",
  "$250,000 - $500,000",
  "$500,000 - $1 million",
  "$1 million - $5 million",
  "More than $5 million"
];

const RevenueStep = ({ onNext, initialValue = "" }) => {
  const [selectedRevenue, setSelectedRevenue] = useState(initialValue);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      className="flex flex-col min-h-[400px] md:min-h-[450px]"
    >
      <div className="space-y-3 mb-6">
        <div className="text-center space-y-1">
          <motion.h2
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-2xl md:text-3xl font-bold text-gray-900"
          >
            What was your total revenue last year?
          </motion.h2>
          <div className="w-12 h-0.5 bg-[#1a4a1a] mx-auto"></div>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
            className="text-gray-500 text-sm md:text-base mt-2"
          >
            Your total business income
          </motion.p>
        </div>
      </div>

      <div className="flex-grow">
        <RadioGroup
          value={selectedRevenue}
          onValueChange={setSelectedRevenue}
          className="grid grid-cols-1 gap-4 max-w-xl mx-auto"
        >
          {revenueRanges.map((range) => (
            <div key={range}>
              <RadioGroupItem
                value={range}
                id={range}
                className="peer sr-only"
              />
              <Label
                htmlFor={range}
                className="flex items-center justify-center rounded-lg border-2 border-slate-200 bg-white p-4 md:p-5 hover:bg-[#1a4a1a]/5 hover:border-[#1a4a1a]/20 peer-data-[state=checked]:border-[#1a4a1a] peer-data-[state=checked]:bg-[#1a4a1a]/5 [&:has([data-state=checked])]:border-[#1a4a1a] cursor-pointer transition-all duration-200 text-base md:text-lg font-medium h-[60px] md:h-[64px]"
              >
                {range}
              </Label>
            </div>
          ))}
        </RadioGroup>
      </div>

      <div className="mt-6">
        <Button
          onClick={() => onNext(selectedRevenue)}
          disabled={!selectedRevenue}
          className="w-full bg-[#1a4a1a] hover:bg-[#1a4a1a]/90 text-white py-3 md:py-4 text-base md:text-lg font-semibold rounded-lg shadow-md hover:shadow-lg transition-all"
        >
          Continue
        </Button>
      </div>
    </motion.div>
  );
};

export default RevenueStep; 